import { render } from "./AuthHandler.vue?vue&type=template&id=5734b021"
import script from "./AuthHandler.vue?vue&type=script&lang=js"
export * from "./AuthHandler.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__